import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d3b5a85"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"600"} }, " Wollen Sie mehr darüber erfahren? ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"24px"} }, " Jetzt kostenloses Beratungsgespräch vereinbaren! ", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Name *")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("E-Mail Adresse *")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Telefonnummer")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Firma")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Ihre Nachricht")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" * Pflichtfelder ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Jetzt Gespräch anfragen! ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" (kostenlos und unverbindlich) ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "In diesem erfahren Sie unter anderem folgendes:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Wie läuft die App Entwicklung ab?"),
  /*#__PURE__*/_createElementVNode("li", null, "Was sind die nächsten Schritte?"),
  /*#__PURE__*/_createElementVNode("li", null, "Wie lange dauert die App Entwicklung?"),
  /*#__PURE__*/_createElementVNode("li", null, "Weitere Fragen? Diese beantworten wir Ihnen gerne.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, { class: "ion-text-center headline" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  size: "0",
                  "size-md": "1",
                  "size-xl": "2"
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-md": "5",
                  "size-xl": "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      class: "box-shadowed small-input",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.store.data.contactInfo.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.store.data.contactInfo.name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-md": "5",
                  "size-xl": "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { class: "box-shadowed small-input" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.store.data.contactInfo.email,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.store.data.contactInfo.email) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  size: "0",
                  "size-md": "1",
                  "size-xl": "2"
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-md": "5",
                  "size-xl": "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { class: "box-shadowed small-input" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.store.data.contactInfo.tel,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.store.data.contactInfo.tel) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-md": "5",
                  "size-xl": "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { class: "box-shadowed small-input" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          modelValue: _ctx.store.data.contactInfo.company,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.store.data.contactInfo.company) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  size: "0",
                  "size-md": "1",
                  "size-xl": "2"
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-md": "10",
                  "size-xl": "8",
                  class: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      class: "box-shadowed",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { position: "floating" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_textarea, {
                          rows: "6",
                          modelValue: _ctx.store.data.contactInfo.message,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.store.data.contactInfo.message) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "center",
          style: {"font-size":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, { class: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              disabled: !_ctx.buttonActive,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendRequest())),
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { style: {"margin-bottom":"30px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          class: "center",
          style: {"font-size":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, { class: "ion-padding-bottom" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          size: "0",
          "size-md": "1",
          "size-xl": "2"
        }),
        _createVNode(_component_ion_col, {
          size: "12",
          "size-md": "11",
          "size-xl": "9"
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}